<template>
  <detail-template :classCustom="'detail-docs'">
    <template #content>
      <div
        class="back-icon border-radius__50 clickable flex-row flex__center"
        @click="backListPage()"
      >
        <i class="el-icon-back font-size__large"></i>
      </div>

      <div class="header">
        <div class="docTags">
          <hc-maybay-state
            v-if="hcFlowInstance"
              :state="hcFlowInstance.currentStateCode"
          />
        </div>
      </div>

      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div
            style="color: #007aff"
            class="font-size__large font-weight__bold margin-top-10 margin-bottom-10"
          >
            Yêu cầu sửa chữa nhỏ
          </div>
          <div class="margin-top-10" v-if="!!requestUserDeptRole">
            <span class="label-input">Đơn vị yêu cầu:</span>
            <span class="font-weight__bold">{{
              requestUserDeptRole.deptName
            }}</span>
          </div>
          <div
            class="margin-top-10 padding-bottom-10 flex-row has-border__bottom"
            v-if="hcCaseSCN && requestUserDeptRole"
          >
            <span class="label-input">Người yêu cầu:</span>
            <div class="flex-row flex__left margin-left-10">
              <span class="font-weight__bold">{{
                requestUserDeptRole.fullName
              }}</span>
            </div>
            <span class="label-input margin-left-10">vào lúc:</span>
            <div class="flex-row flex__left margin-left-10">
              <span class="font-weight__bold">
                {{ hcCaseSCN.createTime | dateFormatter({ nullValue: "-" }) }}
              </span>
            </div>
          </div>

          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            inline-message
            label-width="150px"
          >
            <div class="group__info margin-top-10">
              <div class="content">
                <div class="form-input">
                  <div
                    class="title font-size__small font-weight__bold margin-bottom-10"
                  >
                    Thông tin yêu cầu
                  </div>
                  <el-form-item
                    label="Loại sửa chữa"
                    prop="requestField"
                    class="custom-label__input width25"
                  >
                    <el-select
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold "
                      v-model="form.requestField"
                      placeholder="Lĩnh vực sửa chữa"
                      size="medium"
                      filterable
                      clearable
                      :disabled="!isAbleToCapNhat"
                    >
                      <el-option
                        v-for="item in requestFields"
                        :key="item.id"
                        :label="item.categoryName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="Tên yêu cầu" prop="requestName">
                    <el-input
                      v-model="form.requestName"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      maxlength="100"
                      show-word-limit
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      :readonly="!isAbleToCapNhat"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Thời gian sửa chữa" prop="requestTime">
                    <el-date-picker
                      v-model="form.requestTime"
                      size="medium"
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      type="datetime"
                      placeholder="dd/MM/yyyy HH:mm"
                      format="dd/MM/yyyy HH:mm"
                      :prefix-icon="' '"
                      :readonly="!isAbleToCapNhat"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="Địa điểm sửa chữa" prop="requestAddress">
                    <el-input
                      v-model="form.requestAddress"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      maxlength="100"
                      show-word-limit
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      :readonly="!isAbleToCapNhat"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Số điện thoại" prop="requestPhoneNumber">
                    <el-input
                      v-model="form.requestPhoneNumber"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      maxlength="20"
                      show-word-limit
                      @change="isdnChanged"
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      :readonly="!isAbleToCapNhat"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Nội dung yêu cầu" prop="requestContent">
                    <el-input
                      type="textarea"
                      v-model="form.requestContent"
                      placeholder="Nội dung yêu cầu"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      maxlength="500"
                      show-word-limit
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      :readonly="!isAbleToCapNhat"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </VuePerfectScrollbar>

      <div
        class="footer"
        v-if="
          isAbleToCapNhat || isAbleToHuy || isAbleToPheDuyet || isAbleToTuChoi
        "
      >
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">
            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToCapNhat"
              @click="update"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Cập nhật
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToPheDuyet"
              @click="approve"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Phê duyệt
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToTuChoi"
              @click="reject"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Từ chối
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToHuy"
              @click="cancel"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Hủy
            </el-button>
          </div>
        </div>
      </div>
      <hc-scn-reject-dialog
        v-if="isEnableDialogReject"
        :isOpen="isOpenDialogReject"
        :id="hcCaseSCN.id"
        @dialogClosed="isEnableDialogReject = false"
        @closeDialog="isOpenDialogReject = false"
        @rejectSuccess="rejectSuccess"
      />
      <hc-scn-approve-dialog
        v-if="isEnableDialogApprove"
        :isOpen="isOpenDialogApprove"
        :id="hcCaseSCN.id"
        @dialogClosed="isEnableDialogApprove = false"
        @closeDialog="isOpenDialogApprove = false"
        @approveSuccess="approveSuccess"
      />
      <hc-scn-cancel-dialog
        v-if="isEnableDialogCancel"
        :isOpen="isOpenDialogCancel"
        :id="hcCaseSCN.id"
        @dialogClosed="isEnableDialogCancel = false"
        @closeDialog="isOpenDialogCancel = false"
        @cancelSuccess="cancelSuccess"
      />
    </template>
  </detail-template>
</template>

<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import dateFormatter from "../../../filters/dateFormatter";
  import DetailTemplate from "../../common/detail";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import hcCaseMasterService from "../../../services/hcCaseMasterService";
  import hcFlowInstanceService from "../../../services/hcFlowInstanceService";
  import hcStateToStateService from "../../../services/hcStateToStateService";
  import goBackMixin from "../../../mixins/goBackMixin";
  import constants from "../../../constants";
  import h from "../../../services/h";
  import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
  import HcMaybayState from "../vemaybay/hc-maybay-state";
  // import utils from "../../../services/utils";
  import hanhchinhService from "../../../services/hanhchinhService";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import utils from "../../../services/utils";
  import hcScnRejectDialog from "./hc-scn-reject-dialog"
  import hcScnApproveDialog from "./hc-scn-approve-dialog"
  import hcScnCancelDialog from "./hc-scn-cancel-dialog"
  import categoryService from "../../../services/categoryService";
  // import hanhChinhUtils from "../../../services/hanhChinhUtils";

  export default {
    name: "hc-scn-detail",
    mixins: [handleRequestErrorMixin, goBackMixin],
    filters: {dateFormatter},
    components: {
      DetailTemplate,
      VuePerfectScrollbar,
      hcScnRejectDialog,
      hcScnApproveDialog,
      HcMaybayState,
      hcScnCancelDialog
    },

    data() {
      return {
        hcCaseSCN: null,
        hcFlowInstance: null,
        hcCaseMaster: null,
        nextHcStateToStateActions: null,
        requestUserDeptRole: null,
        requestFields: [],
        form: {
          requestField: null,
          requestName: null,
          requestTime: null,
          requestAddress: null,
          requestContent: null,
          requestPhoneNumber: null
        },
        rules: {
          requestField: null,
          requestName: null,
          requestTime: null,
          requestAddress: null,
          requestContent: null,
          requestPhoneNumber: null,
        },

        isAbleToCapNhat: false,
        isAbleToHuy: false,
        isAbleToPheDuyet: false,
        isAbleToTuChoi: false,
        isEnableDialogReject: false,
        isEnableDialogApprove: false,
        isOpenDialogReject : false,
        isOpenDialogApprove : false,
        isEnableDialogCancel : false,
        isOpenDialogCancel : false


      };
    },

    computed: {
      caseMasterId() {
        return this.$route.params.id;
      },
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      },
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      }
    },

    watch: {
      caseMasterId() {
        this.reloadPage();
      },
      isOpenDialogReject(newValue) {
        if (newValue) this.isEnableDialogReject = newValue;
      },
      isOpenDialogApprove(newValue) {
        if (newValue) this.isEnableDialogApprove = newValue;
      },
      isOpenDialogCancel(newValue) {
        if (newValue) this.isEnableDialogCancel = newValue;
      },
    },

    created() {
      this.initSelectOptions();
      this.initValidationRules();
      this.initPage();
    },

    methods: {
      initValidationRules() {
        let defaultRequiredConstrains = {
          required: true,
          message: "Trường dữ liệu bắt buộc",
          trigger: "blur"
        };

        this.rules.requestName = [defaultRequiredConstrains];
        this.rules.requestField = [defaultRequiredConstrains];
        this.rules.requestAddress = [defaultRequiredConstrains];
        let checkPhoneFormat = utils.buildPhoneValidationRule();
        this.rules.requestPhoneNumber = [{validator: checkPhoneFormat, trigger: "blur"}];
        this.rules.requestTime = [defaultRequiredConstrains];

      },

      isdnChanged() {
        if(this.form.requestPhoneNumber) {
          this.form.requestPhoneNumber = utils.standardlizePhoneNumber(this.form.requestPhoneNumber);
        }
      },
      afterSubmitSuccess() {
        this.notifyMasterForDataChange({});
        this.goBack();
      },

      updateSuccess() {
        this.isOpenDialogUpdate = false;
        this.afterSubmitSuccess();
      },

      loadRequestUserDeptRole() {
        return userDeptRoleViewService
          .findRequesterForHc(this.caseMasterId)
          .then(response => (this.requestUserDeptRole = response.data));
      },

      cancelSuccess() {
        this.isOpenDialogCancel = false;
        this.afterSubmitSuccess();
      },

      approveSuccess(){
        this.isOpenDialogApprove = false;
        this.afterSubmitSuccess();
      },

      rejectSuccess() {
        this.isOpenDialogReject = false;
        this.afterSubmitSuccess();
      },

      async reloadPage() {
        await this.initPage();
      },

      async initPage() {
        await this.loadHcCaseSCN();
        await this.loadHcCaseMaster();
        await this.loadHcFlowInstance();
        await this.loadNextActions();
        await this.loadRequestUserDeptRole();
        await this.initSelectOptions();
        this.initActions();
        this.initFormForEdit();
      },

      async initSelectOptions() {
        categoryService.findAllByCategoryGroupCode(constants.CATEGORY_GROUP_CODE.HC_SCN_LINH_VUC)
          .then(res => this.requestFields = res.data);
      },

      initFormForEdit() {
        this.bindDataToForm(this.form);
      },

      bindDataToForm(form) {
        form.requestField = this.hcCaseSCN.requestField;
        form.requestTime = this.hcCaseSCN.requestTime;
        form.requestAddress = this.hcCaseSCN.requestAddress;
        form.requestName = this.hcCaseSCN.requestName;
        form.requestContent = this.hcCaseSCN.requestContent;
        form.requestPhoneNumber = this.hcCaseSCN.requestPhoneNumber;
        form.note = this.hcCaseSCN.note;
      },

      initActions() {
        /**
         * -  Nếu yêu cầu ở trạng thái Chờ phê duyệt, người gửi yêu cầu và chuyên viên tổng hợp có thể chủ động cập nhật thông tin.
         -  Nếu yêu cầu ở trạng thái Đã phê duyệt thì chỉ người tổng hợp có quyền cập nhật thông tin, có thông báo tới người gửi yêu cầu
         */
        this.isAbleToCapNhat =
          this.isEnableAction(
            constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.CAP_NHAT
          ) &&
          ((this.hcFlowInstance.currentStateCode ===
            constants.HC_STATE.STATE_CODE.MAY_BAY.CHO_PHE_DUYET &&
            (this.isApprover() || this.isRequester())) ||
            (this.hcFlowInstance.currentStateCode ===
              constants.HC_STATE.STATE_CODE.MAY_BAY.DA_PHE_DUYET &&
              this.isApprover()));

        this.isAbleToHuy = this.isEnableAction(
          constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.HUY
        );
        this.isAbleToPheDuyet = this.isEnableAction(
          constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.PHE_DUYET
        );
        this.isAbleToTuChoi = this.isEnableAction(
          constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.TU_CHOI
        );
      },

      isApprover() {
        return (
          this.userDeptRole.roleCode ===
          constants.ROLE.CODE.SUA_CHUA_NHO.DUYET_SUA_CHUA_NHO
        );
      },

      isRequester() {
        return (
          this.userDeptRole.userId === this.hcCaseSCN.requestUserId &&
          this.userDeptRole.roleId === this.hcCaseSCN.requestRoleId &&
          this.userDeptRole.deptId === this.hcCaseSCN.requestDeptId
        );
      },

      isEnableAction(actionCode) {
        return h.exists(
          this.nextHcStateToStateActions,
          hcStateToState => hcStateToState.actionCode === actionCode
        );
      },

      loadNextActions() {
        return hcStateToStateService
          .findAllActionsByHcCaseCommands(this.hcCaseMaster.flowInstanceId)
          .then(response => (this.nextHcStateToStateActions = response.data));
      },

      loadHcFlowInstance() {
        return hcFlowInstanceService
          .findById(this.hcCaseMaster.flowInstanceId)
          .then(response => (this.hcFlowInstance = response.data));
      },

      loadHcCaseMaster() {
        return hcCaseMasterService
          .findById(this.hcCaseSCN.caseMasterId)
          .then(response => (this.hcCaseMaster = response.data));
      },

      loadHcCaseSCN() {
        return hanhchinhService
          .findByHcCaseMaster(this.caseMasterId)
          .then(response => (this.hcCaseSCN = response.data));
      },

      convertToSubmitForm() {
        return {
          requestField: this.form.requestField,
          requestName: this.form.requestName,
          requestAddress: this.form.requestAddress,
          requestTime: this.form.requestTime,
          requestContent: this.form.requestContent,
          requestPhoneNumber : this.form.requestPhoneNumber,
          caseMasterId : this.caseMasterId
        };
      },



      validateForm() {
        return utils.validateFormCommon(this.$refs.form, this.$message);
      },

      update() {
        this.validateForm()
          .then(() => {
            let submitForm = this.convertToSubmitForm();
            return hanhchinhService
              .updateSCNRequest(submitForm)
              .then(response => response.data);
          })
          .then(hcCaseCommands => {
            this.$message.success(
              errorMessageFilter({
                errorCode: "hcSCN.updateSuccess"
              })
            );
            this.afterSubmitSuccess();
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          });
      },

      approve() {
        this.isOpenDialogApprove = true;
      },

      reject() {
        this.isOpenDialogReject = true;
      },

      cancel(){
        this.isOpenDialogCancel = true;
      },



      backListPage() {
        this.goBack();
      }
    }
  };
</script>

<style scoped>
  .error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    margin-left: 10px;
  }

  .tableHeader {
    height: 35px;
  }

  tr {
    text-align: center;
  }

  th {
    font-size: 13px;
    color: black;
    border-bottom: 1px solid #e3e8ee;
  }

  table {
    border: 1px solid #e3e8ee;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/suachuanho/hc-scn-detail.vue